import type React from 'react';

import type { SiteSkipLinkType } from './SiteSkipLinks';

import { moveFocusProgramatically } from '../../../common/utils/programaticFocus';
import SkipButton from './SkipButton';

const SkipLink = (props: {
    href: `#${SiteSkipLinkType}`;
    align?: 'start' | 'center';
    children: React.ReactNode;
}) => {
    return (
        <SkipButton
            align={props.align}
            href={props.href}
            onClick={(e) => {
                // Focus and scroll programmatically to avoid adding a #href to the current URL
                e.preventDefault();
                const target = document.querySelector(props.href) as HTMLElement | null;
                if (target) {
                    moveFocusProgramatically(target);
                }
            }}
        >
            {props.children}
        </SkipButton>
    );
};

export default SkipLink;
